<template>
  <el-dialog
    :visible="true"
    width="90%"
    :show-close="false"
    :close-on-click-modal="false"
    class="detail-page"
    @close="shutDown"
  >
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        width="50px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="交货日期"
      />
      <af-table-column
        fixed
        prop="tradingTimeStr"
        label="交货时间"
      />
      <af-table-column
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="entrustBs"
        label="购/销"
      />
      <af-table-column
        prop="originDeliveryAmount"
        label="交货申请量"
      />
      <af-table-column
        prop="deliveryAmount"
        label="交货量"
      />
      <af-table-column
        prop="calcDepositAmount"
        label="保证金量"
      />
      <af-table-column
        prop="releaseDepositAmount"
        label="保证金已释放量"
      />
      <af-table-column
        prop="calcProfitAmount"
        label="交收盈亏量"
      />
      <af-table-column
        prop="orderGoodsTotalPriceExp"
        label="订货总价"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <div class="detailPage-btns">
      <el-button
        type="primary"
        @click="toDownload"
      >
        导出
      </el-button>
      <el-button @click="shutDown">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import api from '@/api'

export default {
  name: 'Detail',
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        id: this.row.id,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      let res = await api.spotPurchaseSaleInquiry.SettlementXQ(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
    },
    // 关闭弹窗
    shutDown () {
      this.$emit('shutDown')
    },
    // 导出
    toDownload () {
      let param = {
        id: this.row.id,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        exportType: 'DeliverySumDetail'
      }
      this.$utils.getExcelFile(this, api.detail, param)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
  }
}

</script>
